import { merge } from 'lodash-es';
import type { ExportOptions } from '../BlotterTable/types';

export type ResolveEntityAdminExportOptionsArgs = {
  title?: string;
  entityName?: string;
  /** When set, the grid is hierarchical (tree data); export defaults include `baseParams.skipRowGroups: false`. */
  childIDField?: PropertyKey | null;
  /** Partial overrides merged into defaults (defaults supply required fields such as `name`). */
  exportOptions?: Partial<ExportOptions>;
};

/**
 * Resolves CSV/Excel export options for EntityAdmin blotters: default file name (slugified title or entity fallback),
 * hierarchical `skipRowGroups`, and deep-merge with caller `exportOptions`.
 *
 * Call only when the blotter should offer export; suppressed-export callers pass `undefined` as `exportOptions` instead.
 */
export function resolveEntityAdminExportOptions(args: ResolveEntityAdminExportOptionsArgs): ExportOptions {
  const { title, entityName, childIDField, exportOptions: exportOptionsFromProps } = args;

  const trimmedTitle = title?.trim();
  const source = trimmedTitle ? trimmedTitle : `${entityName ?? 'Entity'} Export`;
  const name = source.replace(/\s+/g, '-');

  const defaultExportOptions: ExportOptions = {
    name,
    ...(childIDField != null ? { baseParams: { skipRowGroups: false } } : {}),
  };

  if (exportOptionsFromProps == null) {
    return defaultExportOptions;
  }

  return merge({}, defaultExportOptions, exportOptionsFromProps) as ExportOptions;
}
